var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2059_20673)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.0023 14.9999H18.3359C17.7839 14.9999 17.3359 14.552 17.3359 14C17.3359 13.448 17.7839 13 18.3359 13H31.0023C31.5542 13 32.0022 13.448 32.0022 14C32.0022 14.552 31.5542 14.9999 31.0023 14.9999Z",
    fill: "#00A657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9997 20.0001C25.7436 20.0001 25.4878 19.9026 25.293 19.7068C24.9023 19.316 24.9023 18.6827 25.293 18.2921L29.5863 13.999L25.293 9.7057C24.9023 9.31508 24.9023 8.6818 25.293 8.29119C25.6838 7.90033 26.3171 7.90033 26.7077 8.29119L31.7076 13.291C32.0982 13.6816 32.0982 14.3149 31.7076 14.7055L26.7077 19.7054C26.5117 19.9026 26.2558 20.0001 25.9997 20.0001Z",
    fill: "#00A657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6664 32.0009C10.381 32.0009 10.1103 31.9609 9.83978 31.8769L1.81586 29.2037C0.724098 28.8223 0 27.805 0 26.6679V2.66862C0 1.19796 1.19601 0.00195312 2.66666 0.00195312C2.95181 0.00195312 3.22256 0.041991 3.4933 0.125973L11.517 2.79923C12.609 3.18056 13.3328 4.19787 13.3328 5.33504V29.3343C13.3328 30.8049 12.1371 32.0009 10.6664 32.0009ZM2.66666 2.00189C2.29998 2.00189 1.99994 2.30193 1.99994 2.66862V26.6679C1.99994 26.9518 2.19061 27.2157 2.46257 27.3104L10.4489 29.9717C10.5063 29.9903 10.581 30.001 10.6664 30.001C11.0331 30.001 11.3329 29.701 11.3329 29.3343V5.33504C11.3329 5.05111 11.1422 4.7872 10.8703 4.69248L2.88394 2.03119C2.82657 2.01263 2.75187 2.00189 2.66666 2.00189Z",
    fill: "#00A657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.33 10.6684C19.778 10.6684 19.33 10.2204 19.33 9.6684V3.66859C19.33 2.74991 18.5822 2.00189 17.6636 2.00189H2.66403C2.11205 2.00189 1.66406 1.55391 1.66406 1.00192C1.66406 0.449937 2.11205 0.00195312 2.66403 0.00195312H17.6636C19.6862 0.00195312 21.33 1.64594 21.33 3.66859V9.6684C21.33 10.2204 20.882 10.6684 20.33 10.6684Z",
    fill: "#00A657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6692 28.0004H12.3359C11.7839 28.0004 11.3359 27.5524 11.3359 27.0004C11.3359 26.4484 11.7839 26.0005 12.3359 26.0005H17.6692C18.5879 26.0005 19.3357 25.2524 19.3357 24.3338V18.334C19.3357 17.782 19.7837 17.334 20.3357 17.334C20.8876 17.334 21.3356 17.782 21.3356 18.334V24.3338C21.3356 26.3564 19.6919 28.0004 17.6692 28.0004Z",
    fill: "#00A657"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2059_20673"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutModal);
export default __webpack_public_path__ + "static/media/logout-modal.b5b8237cc22a98b8dc40e9f4c562331e.svg";
export { ForwardRef as ReactComponent };